import React, { useContext } from 'react';
import styled from 'styled-components';
import RoleProtected, { userRoles } from '../RoleProtected';
import Row from '../layout/Row';
import { useGlobalState } from '../stateProvider/StateProvider';
import Icon from './Icon';
import { HelpToolContext } from '../HelpToolTip';

const Icons = styled(Icon)`
    opacity: 0.5;
    transition: all 0.3s;
    cursor: pointer;

    &: hover {
        opacity: 1;
    }
`

const TooltipHelper = ({ formName, name, ...props }) => {
    const {
        state: { help = {} },
    } = useGlobalState();

    // const { setHoverTip, updateHelp, removeHelp } = useContext(HelpToolContext);
    const context = useContext(HelpToolContext);

    if (!context) return;

    const { setHoverTip, updateHelp, removeHelp } = context;

    const formHelp = help[formName] || {};

    return formName ? (
        <Row>
            {formHelp[name] && (
                <Icons
                    icon='questionMark'
                    style={{ fontSize: '0.8em' }}
                    onMouseMove={(event) => setHoverTip(event, formHelp[name], 1)}
                    onMouseLeave={(event) => setHoverTip(event, formHelp[name], 0)}
                />
            )}
            <RoleProtected roles={[userRoles.technicalInterfaceMaven]}>
                <Icons
                    icon={formHelp[name] ? 'edit' : 'plus'}
                    style={{ fontSize: '0.8em' }}
                    onClick={() => updateHelp(formName, name)}
                />

                {formHelp[name] && (
                    <Icons
                        icon='minus'
                        style={{ fontSize: '0.8em' }}
                        onClick={() => removeHelp(formName, name)}
                    />
                )}
            </RoleProtected>
        </Row>
    ) : null;
}

export default TooltipHelper;
